import { faAddressBook, faBuilding, faHeadset, faMobile } from '@fortawesome/pro-regular-svg-icons';

import { ContactType } from '@cloud-wave/neon-common-lib';

export const ICON_MAP = {
  [ContactType.EXTERNAL_DIRECTORY]: faAddressBook,
  [ContactType.ORGANISATION]: faBuilding,
  [ContactType.PERSONAL]: faMobile,
  [ContactType.AGENT]: faHeadset,
};
